<!-- Overlay pull-to-refresh: content/header stay fixed; only the indicator
     descends from above the top edge as the user pulls. -->
<div class="pf-ptr-wrapper">
    <!-- Material-style progress ring: the arc fills as the user pulls, then
         spins while refreshing. -->
    <div
        class="pf-ptr-indicator"
        [class.pf-ptr-indicator--spinning]="isRefreshing"
        [class.pf-ptr-indicator--animating]="indicatorAnimating"
        [style.opacity]="isRefreshing ? 1 : indicatorOpacity"
        [style.transform]="
            'translateX(-50%) translateY(' + indicatorOffset + 'px)'
        "
        aria-hidden="true">
        <svg class="pf-ptr-ring" viewBox="0 0 36 36" width="36" height="36">
            <circle
                class="pf-ptr-ring__track"
                cx="18"
                cy="18"
                r="14"
                fill="none"></circle>
            <circle
                class="pf-ptr-ring__progress"
                cx="18"
                cy="18"
                r="14"
                fill="none"
                stroke-linecap="round"
                [attr.stroke-dasharray]="ringCircumference"
                [attr.stroke-dashoffset]="
                    isRefreshing ? ringCircumference * 0.75 : ringDashoffset
                "></circle>
        </svg>
        @if (!isRefreshing) {
            <span
                nz-icon
                nzType="reload"
                nzTheme="outline"
                class="pf-ptr-glyph"
                [style.transform]="'rotate(' + glyphRotation + 'deg)'">
            </span>
        }
    </div>

    <ng-content></ng-content>
</div>
